import { getIn } from "formik";
import { UploadItemState } from "../../../components/Polyfill";
import { Output } from "../../../Text";

function validateDocument(document: any) {
    if (document.filter((f: any) => f.state === UploadItemState.LOADING).length) {
        return Output.resolve("generic.errors.D004");
    } else {
        const effectiveFileCount = document?.filter((f) => f.state === UploadItemState.SUCCESS)?.length || 0;

        if (effectiveFileCount <= 0) {
            return Output.resolve("generic.errors.D010");
        } else if (effectiveFileCount > 3) {
            return Output.template(
                Output.resolve("generic.errors.D008"),
                { maxCount: 3 }
            );
        }
        return undefined;
    }

}

export function validateDocumentUpload(values: any, isEuCitizen: boolean) {
    const personalIdDocument = getIn(values, 'personalId');
    const residencyPermitDocument = getIn(values, 'residencyPermit');
    const incomeProofDocument = getIn(values, 'incomeProof');

    const personalIdValidation = validateDocument(personalIdDocument);
    const residencyPermitValidation = !isEuCitizen && validateDocument(residencyPermitDocument);
    const incomeProofValidation = validateDocument(incomeProofDocument);

    const errors: any = {}
    if (personalIdValidation) {
        errors.personalId = personalIdValidation;
    }
    if (residencyPermitValidation) {
        errors.residencyPermit = residencyPermitValidation;
    }
    if (incomeProofValidation) {
        errors.incomeProof = incomeProofValidation;
    }

    return errors;
}